import React from 'react';
import { useNavigate } from 'react-router-dom';

function LinkedInIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="6" fill="#0A66C2"/>
      <path d="M10.667 13.333H7.333V24h3.334V13.333zM9 11.8a1.933 1.933 0 110-3.867A1.933 1.933 0 019 11.8zM24.667 24h-3.334v-5.2c0-1.24-.022-2.834-1.727-2.834-1.728 0-1.993 1.348-1.993 2.742V24h-3.333V13.333h3.2v1.454h.045c.446-.845 1.535-1.734 3.16-1.734 3.38 0 4.005 2.227 4.005 5.12L24.667 24z" fill="white"/>
    </svg>
  );
}

export default function SoftLoginModal({ onDismiss, triggerKind }) {
  const navigate = useNavigate();

  const handleSignIn = () => {
    const views = parseInt(localStorage.getItem('fv_page_views')   || '0', 10);
    const time  = parseInt(localStorage.getItem('fv_time_seconds') || '0', 10);
    window.__posthog?.capture('soft_login_converted', {
      trigger:          triggerKind,
      views_at_trigger: views,
      time_at_trigger:  time,
    });
    navigate('/sign-in');
  };

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onDismiss}
        style={{
          position: 'fixed', inset: 0,
          background: 'rgba(0,0,0,0.6)',
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          zIndex: 1100,
        }}
      />

      {/* Modal */}
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="soft-login-title"
        style={{
          position: 'fixed', top: '50%', left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1101,
          width: 'min(440px, 92vw)',
          background: 'rgba(17,26,46,0.92)',
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)',
          border: '1px solid rgba(233,160,32,0.18)',
          borderRadius: 14,
          padding: '36px 32px 32px',
          boxShadow: '0 24px 64px rgba(0,0,0,0.7), 0 0 0 1px rgba(233,160,32,0.06) inset',
          textAlign: 'center',
        }}
      >
        {/* Close */}
        <button
          onClick={onDismiss}
          aria-label="Close"
          style={{
            position: 'absolute', top: 14, right: 14,
            background: 'none', border: 'none',
            color: '#8892a5', fontSize: 20,
            cursor: 'pointer', lineHeight: 1, padding: '4px 8px',
          }}
        >
          ×
        </button>

        {/* LinkedIn icon */}
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
          <LinkedInIcon />
        </div>

        <h2
          id="soft-login-title"
          style={{
            fontFamily: "var(--font-display, 'Fraunces', serif)",
            fontSize: 20, fontWeight: 700,
            color: '#fff', margin: '0 0 10px',
          }}
        >
          Enjoying FathomVoyage?
        </h2>

        <p style={{
          fontFamily: "var(--font-body, 'Figtree', sans-serif)",
          fontSize: 14, color: '#8892a5',
          lineHeight: 1.65, margin: '0 0 28px',
        }}>
          Sign in with LinkedIn to save your preferences, set price alerts, and get early access to Pro features.
        </p>

        {/* Primary CTA */}
        <button
          onClick={handleSignIn}
          style={{
            width: '100%',
            padding: '12px 0',
            background: '#0A66C2',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            fontFamily: "var(--font-body, 'Figtree', sans-serif)",
            fontSize: 15, fontWeight: 700,
            cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
            marginBottom: 12,
            transition: 'opacity 0.15s',
          }}
          onMouseEnter={e => e.currentTarget.style.opacity = '0.88'}
          onMouseLeave={e => e.currentTarget.style.opacity = '1'}
        >
          <svg width="16" height="16" viewBox="0 0 32 32" fill="none" style={{ flexShrink: 0 }}>
            <path d="M10.667 13.333H7.333V24h3.334V13.333zM9 11.8a1.933 1.933 0 110-3.867A1.933 1.933 0 019 11.8zM24.667 24h-3.334v-5.2c0-1.24-.022-2.834-1.727-2.834-1.728 0-1.993 1.348-1.993 2.742V24h-3.333V13.333h3.2v1.454h.045c.446-.845 1.535-1.734 3.16-1.734 3.38 0 4.005 2.227 4.005 5.12L24.667 24z" fill="white"/>
          </svg>
          Sign in with LinkedIn
        </button>

        {/* Secondary CTA */}
        <button
          onClick={onDismiss}
          style={{
            width: '100%',
            padding: '10px 0',
            background: 'transparent',
            color: '#8892a5',
            border: '1px solid #1e2d44',
            borderRadius: 8,
            fontFamily: "var(--font-body, 'Figtree', sans-serif)",
            fontSize: 14,
            cursor: 'pointer',
            transition: 'border-color 0.15s, color 0.15s',
          }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = '#2a3f5f'; e.currentTarget.style.color = '#c4ccd8'; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = '#1e2d44'; e.currentTarget.style.color = '#8892a5'; }}
        >
          Maybe later
        </button>
      </div>
    </>
  );
}
